import React from 'react'
import {
  fetchLoanHistory,
  fetchLoanTransactions,
} from '../../actions/loanActions'
import { connect } from 'react-redux'
import { selectLoanHistory, selectLoanTransactions } from '../../reducers'
import { RefiTransactionsLoanHistoryProps } from './refiTransactionsLoanHistory.types'
import { format } from '../../helpers/loanHistoryFormatHelper'
import { RefiTransactionsLoanTransactions } from './refiTransactionsLoanTransactions'

const CARD_TITLE_HEIGHT = 50

const SimpleValueRow = ({ keyName, value }) => (
  <div className="refiTransactionCard__row">
    <div className="refiTransactionCard__fields">
      <div>{format.string(keyName)}</div>
    </div>
    <div className="refiTransactionCard__values refiTransactionCard__bold">
      <div>{format.value(keyName, value)}</div>
    </div>
  </div>
)

const CardRow = ({ keyName, value }) => (
  <>
    <div style={{ height: '2rem' }} />
    {value.map((item, idx: number) => (
      <React.Fragment key={idx}>
        <div className="refiTransactionCard__row refiTransactionCard__row__full">
          <div className="refiTransactionCard ">
            <div
              style={{ height: CARD_TITLE_HEIGHT, top: CARD_TITLE_HEIGHT }}
              className="refiTransactionCard__title refiTransactionCard__stick-to-top"
            >
              {format.string(format.customKeyName(keyName))} {idx + 1}
            </div>
            <div className="refi-transactions-info__card">
              {Object.entries(item).map(([keyName, value], entryIdx) => (
                <SimpleValueRow key={entryIdx} {...{ keyName, value }} />
              ))}
            </div>
          </div>
        </div>
        <div style={{ height: '2rem' }} />
      </React.Fragment>
    ))}
  </>
)

export const RefiTransactionsLoanHistory = (
  props: RefiTransactionsLoanHistoryProps
) => {
  const { fetchLoanHistory, loanHistory } = props
  const loanId = props.match.params.id
  const { loading, data: decisionHistory } = loanHistory
  const { fetchLoanTransactions, loanTransactions } = props
  const { data: loanTransactionsData } = loanTransactions

  React.useEffect(() => {
    fetchLoanTransactions(loanId)
  }, [])

  React.useEffect(() => {
    fetchLoanHistory(loanId)
  }, [])

  return (
    <div>
      <div className="refi-transactions-info">
        <div className="refi-transactions-info__header">
          Loan History id: {loanId}
          {loading && (
            <span className="refiTransactionCard__rating">Loading...</span>
          )}
        </div>
        <div className="refi-transactions-info__information">
          {decisionHistory.map((decision, idx, arr) => {
            const entries = Object.entries(decision)
              //Filter out entries which the value is an empty array
              .filter(
                (entry) => !(Array.isArray(entry[1]) && entry[1].length === 0)
              )
              //Filter out entries which the value is null
              .filter((entry) => entry[1] !== null)

            return (
              <div key={idx} className="refiTransactionCard">
                <div
                  style={{ height: CARD_TITLE_HEIGHT, zIndex: 1 }}
                  className="refiTransactionCard__title refiTransactionCard__stick-to-top refiTransactionCard__colored-background"
                >
                  Decision {arr.length - idx}
                  <div className="refiTransactionCard__status " />
                </div>
                <div className="refi-transactions-info__card">
                  {entries.map(([keyName, value], entryIdx) =>
                    Array.isArray(value) ? (
                      <CardRow key={entryIdx} {...{ keyName, value }} />
                    ) : (
                      <SimpleValueRow key={entryIdx} {...{ keyName, value }} />
                    )
                  )}
                </div>
              </div>
            )
          })}
        </div>
        {loanTransactionsData && (
          <RefiTransactionsLoanTransactions
            loanTransactions={loanTransactionsData}
          />
        )}
      </div>
    </div>
  )
}

RefiTransactionsLoanHistory.displayName = 'RefiTransactionsLoanHistory'

const mapStateToProps = (state) => ({
  loanHistory: selectLoanHistory(state),
  loanTransactions: selectLoanTransactions(state),
})

const mapDispatchToProps = {
  fetchLoanHistory,
  fetchLoanTransactions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefiTransactionsLoanHistory)
